import React from "react";
import Svg, { Path } from "react-native-svg";

const UpSpeed = (props) => {
  const { color = "#fff", height = 14, width = 14 } = props;

  return (
    <Svg
      width="16"
      height="9"
      viewBox="0 0 16 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M12.0831 1.87187L9.17754 4.38828L7.98143 2.01419C7.91818 1.88864 7.74913 1.8578 7.64504 1.95281L0.420856 8.54726C0.341168 8.62 0.331664 8.74041 0.398927 8.82509C0.465495 8.90888 0.58573 8.93051 0.677675 8.87523L6.65663 5.28008L8.18983 8.16228C8.25412 8.28313 8.41751 8.31287 8.5208 8.22251L13.4728 3.89081L14.004 4.67872C14.1038 4.82666 14.3343 4.79426 14.3854 4.62512L15.5102 0.90537C15.5518 0.767847 15.4412 0.630735 15.2944 0.637833L11.6638 0.813419C11.4924 0.82171 11.4023 1.01486 11.5079 1.14777L12.0831 1.87187Z"
        fill="#27AE60"
      />
    </Svg>
  );
};

export default UpSpeed;
